import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import round from 'lodash/round';
import last from 'lodash/last';
import Icon from '../components/atoms/Icon';
import IconFileType from '../components/atoms/IconFileType';
import SimpleButton from '../components/atoms/SimpleButton';


const getFilesize = size => {
  return round(size/1000000, 2)+' MB';
};

class FileUpload extends React.Component {
    constructor() {
      super();
      this.onDrop = this.onDrop.bind(this);
      this.onDelete = this.onDelete.bind(this);
      this.generatePreview = this.generatePreview.bind(this);
      this.checkFileType = this.checkFileType.bind(this);
      this.state = { file: '', preview: '', errorMsg: '', isUploading : false }
    }

    onDrop(acceptedFiles, rejectedFiles) {
      let errorMsg = '';
      if(acceptedFiles.length) {
        
        this.generatePreview(acceptedFiles[0]);
      } else if(rejectedFiles.length) {
        let rejected = rejectedFiles[0];
        if(rejected.type!=='') {
          let fileType = rejected.type.split('/')[1];
          // if(this.props.uploadTypes.indexOf(fileType)===-1) {
          if("jpg,jpeg,pdf".indexOf(fileType)===-1) {
            errorMsg = 'Die Datei hat nicht das richtige Dateiformat.';
          } else {
            this.generatePreview(rejectedFiles[0]);
          }
          
        } else if(rejected.size>this.props.maxSize) {
          errorMsg = 'Die Datei ist zu gross ('+getFilesize(rejected.size)+'). Maximal erlaubt: '+getFilesize(this.props.maxSize);
        } else {

           this.generatePreview(rejectedFiles[0]);
        }

      }
      
      this.setState({ errorMsg: errorMsg });
      
      
      
    }
    onDelete(evt) {
      evt.preventDefault();
      if(this.state.isUploading) {
        return;
      }
      this.setState({ file: '', preview: '', errorMsg:'' });
    }
    onUpload(evt) {
      evt.preventDefault();
      this.setState({ isUploading: true }, function() {
        this.props.handleUpload(this.state.file);
      });
      
    }

    generatePreview(file) {
      if(file && file.type.match('image.*')) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.setState({
            file: file,
            preview: <img src={reader.result} alt="preview" className="preview" style={{maxWidth:this.props.previewWidth}} />
          });
        }
      } else {
        this.setState({
          file: file,
          preview: this.checkFileType(file)
        });
      }
    }

    checkFileType(file) {
      let filetype = 'file';
      if(file.type.indexOf('/')!==-1) {
        filetype = last(file.type.split('/'));
      }
      
      return <IconFileType filetype={filetype} size={this.props.previewWidth} />;
    };


    render () {
        return (
            <div className={`uploader${this.props.active?" active":""}${this.state.file!==''?" hasfile":""}${this.state.isUploading?" isUploading":""}`}>
              <h4>{this.props.headline}</h4>
              <div className={`coverup${this.props.isUploading?" active":""}`}></div>
              <Dropzone
                className="dropzone"
                accept={this.props.uploadTypes}
                activeClassName="dropzone-active"
                acceptClassName="dropzone-accept"
                rejectClassName="dropzone-reject"
                disableClick={this.state.file!=='' || this.state.isUploading?true:false}
                onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)}
                multiple={false}
                maxSize={512000}
                name={this.props.name}
              >
                <div className="uploadcontent">
                  <p>{this.props.desc}</p>
                  {this.state.errorMsg!==''?<p className="errorMsg">{this.state.errorMsg}</p>:null}
                  <div className="droppedfiles">
                    {
                      this.state.file!==''?
                      <div className="filepreview">
                        <div className="previewimg">
                          {this.state.preview!==''?this.state.preview:''}
                          <div className="filespecs">
                            <span>{this.state.file.name}</span>
                            <span>{getFilesize(this.state.file.size)}</span>
                          </div>
                        </div>
                          <div className="uploadactions">
                            <SimpleButton children="Hochladen" spinner={this.state.isUploading} onClick={(evt) => this.onUpload(evt)} />
                            <div className="deleteicon"><Icon filename="delete" onClick={(evt) => this.onDelete(evt)} /></div>
                          </div>
                          
                        
                      </div>
                      :null
                    }
                </div>
                </div>
              </Dropzone>
              
            </div>
        );
    }

}


FileUpload.propTypes = {
  headline: PropTypes.string,
  desc: PropTypes.string,
  uploadTypes: PropTypes.string,
  previewWidth: PropTypes.string,
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  name: PropTypes.string,
  maxSize: PropTypes.number,
  isUploading: PropTypes.bool
}

FileUpload.defaultProps = {
  headline: "Upload Bescheinigung",
  desc: "Ziehen Sie die Datei (JPG oder PDF) auf dieses Feld, oder klicken Sie hier, um die Datei manuell zu wählen.",
  name: "certificate",
  uploadTypes: "image/jpg,image/jpeg,application/pdf",
  previewWidth: "100px",
  maxSize: 5120000,
  isUploading: false
}

export default FileUpload;


// WEBPACK FOOTER //
// ./src/utils/FileUpload.js